import React from "react";
import { connect } from "react-redux";
import AccessRightTable from "./components/AccessRightTable";

const AccessRights = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<AccessRightTable/>

	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	filters: state.accessRight.accessRightList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessRights);